import type { HostRibbonState } from './hostRibbonContract';
import {
  isHostRibbonOwner,
  releaseHostRibbonOwnership,
  type HostRibbonOwnerToken,
} from './hostRibbonOwnership';
import { postHostRibbonState } from './hostRibbonTransport';

/** Publishes ribbon state, dropping anything sent by a superseded owner. */
export const publishHostRibbonState = (
  token: HostRibbonOwnerToken | null | undefined,
  state: HostRibbonState
): boolean => {
  if (!isHostRibbonOwner(token)) {
    return false;
  }

  postHostRibbonState(state);

  return true;
};

/** Hides the ribbon when its current owner leaves; a stale owner hides nothing. */
export const retireHostRibbonOwner = (
  token: HostRibbonOwnerToken | null | undefined
): boolean => {
  if (!releaseHostRibbonOwnership(token)) {
    return false;
  }

  postHostRibbonState({ visible: false });

  return true;
};
